export const ChatKitStarFilledIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => (
  <svg
    width="54"
    height="52"
    viewBox="0 0 54 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_2694_2235)">
      <path
        d="M12.1825 16.2801L13.9436 15.3461C14.4607 15.0563 14.8866 14.6054 15.1603 14.0579L16.0393 12.1932C16.161 11.9356 16.526 11.9356 16.6477 12.1932L17.5298 14.0579C17.8035 14.6054 18.2293 15.0563 18.7434 15.3461L20.5076 16.2801C20.7509 16.4089 20.7509 16.7922 20.5076 16.921L18.7434 17.8549C18.2293 18.1448 17.8035 18.5957 17.5298 19.1432L16.6477 21.0078C16.526 21.2655 16.161 21.2655 16.0393 21.0078L15.1603 19.1432C14.8866 18.5957 14.4607 18.1448 13.9436 17.8549L12.1825 16.921C11.9392 16.7922 11.9392 16.4411 12.1825 16.2801Z"
        fill="white"
      />
      <path
        d="M41.4062 25.4826L37.3334 27.6371C36.1198 28.2812 35.1161 29.3408 34.5077 30.629L32.4728 34.9413C32.1687 35.55 31.3474 35.55 31.0432 34.9413L29.0084 30.629C28.4001 29.3408 27.3993 28.2812 26.1827 27.6371L22.113 25.4826C21.5046 25.1605 21.5046 24.2588 22.0825 23.9689L26.1827 21.8144C27.3993 21.1703 28.4001 20.1075 29.0084 18.8225L31.0432 14.5102C31.3474 13.9015 32.1687 13.9015 32.4728 14.5102L34.5077 18.8225C35.1161 20.1075 36.1198 21.1703 37.3334 21.8144L41.4062 23.9689C41.9841 24.291 41.9841 25.1605 41.4062 25.4826Z"
        fill="white"
      />
      <path
        d="M23.1311 35.7198L21.3669 36.6538C20.8529 36.9436 20.427 37.3945 20.1533 37.942L19.2712 39.8067C19.1495 40.0643 18.7845 40.0643 18.6629 39.8067L17.7838 37.942C17.5101 37.3945 17.0842 36.9436 16.5672 36.6538L14.806 35.7198C14.5627 35.591 14.5627 35.2399 14.806 35.0789L16.5672 34.145C17.0842 33.8551 17.5101 33.4042 17.7838 32.8568L18.6629 30.9921C18.7845 30.7344 19.1495 30.7344 19.2712 30.9921L20.1533 32.8568C20.427 33.4042 20.8529 33.8551 21.3669 34.145L23.1311 35.0789C23.3744 35.2077 23.3744 35.591 23.1311 35.7198Z"
        fill="white"
      />
    </g>
    <path
      d="M13.2593 16.3632L14.5648 15.6708C14.9481 15.456 15.2638 15.1218 15.4667 14.7159L16.1183 13.3337C16.2085 13.1427 16.479 13.1427 16.5692 13.3337L17.2231 14.7159C17.426 15.1218 17.7417 15.456 18.1227 15.6708L19.4305 16.3632C19.6108 16.4587 19.6108 16.7427 19.4305 16.8382L18.1227 17.5306C17.7417 17.7454 17.426 18.0796 17.2231 18.4855L16.5692 19.8677C16.479 20.0587 16.2085 20.0587 16.1183 19.8677L15.4667 18.4855C15.2638 18.0796 14.9481 17.7454 14.5648 17.5306L13.2593 16.8382C13.0789 16.7427 13.0789 16.4825 13.2593 16.3632Z"
      fill="url(#paint0_linear_2694_2235)"
    />
    <path
      d="M39.883 25.3612L36.4667 27.1685C35.4487 27.7088 34.6067 28.5975 34.0964 29.6781L32.3895 33.2954C32.1344 33.8059 31.4455 33.8059 31.1904 33.2954L29.4835 29.6781C28.9732 28.5975 28.1338 27.7088 27.1132 27.1685L23.6994 25.3612C23.1892 25.0911 23.1892 24.3346 23.6739 24.0915L27.1132 22.2842C28.1338 21.744 28.9732 20.8525 29.4835 19.7746L31.1904 16.1573C31.4455 15.6468 32.1344 15.6468 32.3895 16.1573L34.0964 19.7746C34.6067 20.8525 35.4487 21.744 36.4667 22.2842L39.883 24.0915C40.3678 24.3617 40.3678 25.0911 39.883 25.3612Z"
      fill="url(#paint1_linear_2694_2235)"
    />
    <path
      d="M22.054 35.6361L20.7462 36.3284C20.3652 36.5433 20.0495 36.8775 19.8466 37.2833L19.1928 38.6656C19.1026 38.8566 18.832 38.8566 18.7418 38.6656L18.0902 37.2833C17.8873 36.8775 17.5716 36.5433 17.1883 36.3284L15.8828 35.6361C15.7025 35.5406 15.7025 35.2804 15.8828 35.161L17.1883 34.4687C17.5716 34.2538 17.8873 33.9196 18.0902 33.5138L18.7418 32.1315C18.832 31.9405 19.1026 31.9405 19.1928 32.1315L19.8466 33.5138C20.0495 33.9196 20.3652 34.2538 20.7462 34.4687L22.054 35.161C22.2344 35.2565 22.2344 35.5406 22.054 35.6361Z"
      fill="url(#paint2_linear_2694_2235)"
    />
    <defs>
      <filter
        id="filter0_d_2694_2235"
        x="0"
        y="0"
        width="53.8398"
        height="52"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="6" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.910465 0 0 0 0 0.852314 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2694_2235" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2694_2235"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2694_2235"
        x1="13.3296"
        y1="14.0787"
        x2="19.8875"
        y2="17.0232"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4EB2F4" />
        <stop offset="0.211538" stop-color="#4076F9" />
        <stop offset="0.769231" stop-color="#7A3ADB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2694_2235"
        x1="23.854"
        y1="18.1061"
        x2="41.0842"
        y2="25.8535"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4EB2F4" />
        <stop offset="0.211538" stop-color="#4076F9" />
        <stop offset="0.769231" stop-color="#7A3ADB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2694_2235"
        x1="15.9532"
        y1="32.8766"
        x2="22.511"
        y2="35.8211"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4EB2F4" />
        <stop offset="0.211538" stop-color="#4076F9" />
        <stop offset="0.769231" stop-color="#7A3ADB" />
      </linearGradient>
    </defs>
  </svg>
)
